"use strict";
/**
 * Supplier Overlay Types
 *
 * Parallel data layer for QVET suppliers. Stores HVP-specific tags
 * without polluting `qvet_suppliers` (which is upsert-overwritten on every QVET sync).
 *
 * Currently used to flag which suppliers are study providers (so they show up
 * in the ExternalStudy form). Category (LAB/IMAGING) lives in StudyTypeCatalog,
 * not here — the supplier just needs a yes/no flag.
 */
Object.defineProperty(exports, "__esModule", { value: true });
